export const setUserRegisterId = (id) => {
    localStorage.setItem('userRegisterId', id);
};

export const getUserRegisterId = () => localStorage.getItem('userRegisterId');

export const deleteUserRegisterId = () => {
    localStorage.removeItem('userRegisterId');
};
